import * as types from './ActionTypes';
import { isChinaUser } from '../utils/ChinaUtil';
import { gcApi } from 'config/axios';

export const requestSegmentType = () => ({
    type: types.REQUEST_SEGMENT_TYPES
});

export const receiveSegmentType = (json) => ({
    type: types.RECEIVE_SEGMENT_TYPES,
    segmentTypes: json,
    receivedAt: Date.now()
});

export const requestSurfaceType = () => ({
    type: types.REQUEST_SURFACE_TYPES
});

export const receiveSurfaceType = (json) => ({
    type: types.RECEIVE_SURFACE_TYPES,
    surfaceTypes: json,
    receivedAt: Date.now()
});

export const updateSegment = (data) => {
    return {
        type: types.UPDATE_SEGMENT,
        data
    };
};

export const setSegmentsFilters = (filterName, filterValue, onlyOneValueSelected) => ({
    type: types.SET_SEGMENTS_FILTERS,
    filterName,
    filterValue,
    onlyOneValueSelected
});

export const requestActivityPolylineForSegment = (activityId) => {
    return {
        type: types.REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT,
        activityId
    };
};

const requestActivityPolylineForForBaiduConvert = () => {
    return {
        type: types.REQUEST_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT
    };
};

export const receiveActivityPolylineForSegment = (data, activityId) => {
    return {
        type: types.RECEIVE_ACTIVITY_POLYLINE_FOR_SEGMENT,
        data,
        activityId,
        receivedAt: Date.now()
    };
};

export const requestActivityPolylineForSegmentFail = (error) => {
    return {
        type: types.REQUEST_ACTIVITY_POLYLINE_FOR_SEGMENT_FAIL,
        error
    };
};

const receiveActivityPolylineForBadiuConvert = (data, polyline) => {
    return {
        type: types.RECEIVE_ACTIVITY_POLYLINE_FOR_BAIDU_CONVERT,
        data,
        polyline,
        receivedAt: Date.now()
    };
};

export const fetchActivityPolylineForSegmentBaiduConvert = (activityId) => {
    return gcApi.get(`/segment-service/segment/activity/${activityId}`);
};

export const saveSegment = (json) => {
    if (isChinaUser()) {
        json.coordinateSystem = 'BD09';
    }

    if (json.uuid) {
        return gcApi.put(`/segment-service/segment/${json.uuid}`, json);
    } else {
        return gcApi.post('/segment-service/segment/', json);
    }
};

export const requestSegmentDetails = (segmentId, callback) => {
    return {
        type: types.REQUEST_SEGMENT_DETAILS,
        segmentId,
        callback
    };
};

export const resetCurrentSegmentInfo = () => {
    return {
        type: types.RESET_SEGMENT_INFO
    };
};

export const receiveSegmentDetails = (data, segmentId) => {
    return {
        type: types.RECEIVE_SEGMENT_DETAILS,
        data,
        segmentId,
        receivedAt: Date.now()
    };
};

export const requestSegmentLeaderBoard = (data, isEndlessLoading) => {
    return {
        type: types.REQUEST_SEGMENT_LEADERBOARD,
        data,
        isEndlessLoading
    };
};

export const receiveSegmentLeaderBoard = (data, isEndlessLoading) => {
    return {
        type: types.RECEIVE_SEGMENT_LEADERBOARD,
        data,
        isEndlessLoading: !!isEndlessLoading,
        receivedAt: Date.now()
    };
};

export const setOpenedFilter = (data) => {
    return {
        type: types.SET_OPENED_FILTER,
        data
    };
};

export const resetOpenedFilter = () => {
    return {
        type: types.RESET_OPENED_FILTER
    };
};

export const segmentDetailsError = (error) => {
    return {
        type: types.RECEIVE_SEGMENTS_ERROR,
        error: error
    };
};

export const fetchSegmentLeaderBoardOnlyMe = (segmentId, displayName) => {
    return {
        type: types.REQUEST_SEGMENT_LEADERBOARD_ONLY_ME,
        segmentId: segmentId,
        displayName: displayName,
        meta: {
            cacheTime: 600000 // 10 min
        }
    };
};

export const setSegmentsSelectedTab = (selectedTab) => {
    return {
        type: types.SELECT_SEGMENTS_TAB,
        selectedTab
    };
};

export const requestSegments = (filters = {}, callback) => {
    return {
        type: types.REQUEST_SEGMENTS,
        filters,
        callback
    };
};

export const receiveSegments = (data) => {
    return {
        type: types.RECEIVE_SEGMENTS,
        data: data.segmentUserDTOList || data.segments,
        receivedAt: Date.now()
    };
};

export const toggleSegmentFavorite = (segmentpk, favorite) => ({
    type: types.TOGGLE_FAVORITE_SEGMENT,
    segmentpk,
    favorite
});

export const setSegmentFavoriteStatusInSegmentDetails = (favorite) => {
    return {
        type: types.TOGGLE_FAVORITE_SEGMENT_IN_SEGMENT_DETAILS,
        favorite
    };
};

export const addSegmentToFavourites = (segment) => ({
    type: types.ADD_SEGMENT_TO_FAVOURITES,
    segment
});

export const removeSegmentFromFavourites = (segment) => ({
    type: types.REMOVE_SEGMENT_FROM_FAVOURITES,
    segment
});

export const deletedSegment = (response, segmentUuid) => {
    return {
        type: types.DELETED_SEGMENT,
        response,
        segmentUuid
    };
};

export const deleteSegment = (segmentUuid, callback) => {
    return {
        type: types.DELETE_SEGMENT,
        segmentUuid,
        callback
    };
};

export const requestFavoriteGroupActivities = (administeredGroupId, segmentPk) => {
    return {
        type: types.REQUEST_FAVORITE_GROUP_SEGMENT,
        administeredGroupId,
        segmentPk
    };
};

export const receiveFavoriteGroupActivities = (response) => {
    return {
        type: types.RECEIVE_FAVORITE_GROUP_SEGMENT,
        response
    };
};

export const resetFavoriteGroupActivities = () => {
    return {
        type: types.RESET_FAVORITE_GROUP_SEGMENT
    };
};

export const deleteFavoriteGroupActivities = (item) => ({
    type: types.DELETE_FAVORITE_GROUP_SEGMENT,
    item
});

export const updateFavoriteGroupActivities = (item) => ({
    type: types.UPDATE_FAVORITE_GROUP_SEGMENT,
    item
});

export const resetSegmentPageData = () => {
    return { type: types.RESET_SEGMENT_PAGE };
};
